import React, { useState } from 'react';
import './theme_customizer.scss'
import { __ } from '@wordpress/i18n';
var plugin_url = nxtext_ajax_object.nxtex_url;
import { nxtdash_save_data, nxtdash_install_theme, nxtdash_fetch_api } from '../../apicall';
import nxtds_icons from '../../dashIcon';

var activateTheme = nxtext_ajax_object?.dashData?.nexterThemeActive || false;
var nexterCustLink = nxtext_ajax_object?.dashData?.nexterCustLink || '';
const adminLink = nxtext_ajax_object?.adminUrl || '';

var Theme_cstm_crds = [
    {
        key: 'theme-performance',
        name: __('Nexter Theme Optimization Controls', 'nexter-extension'),
        crd_desc: __('Enable or disable core theme features to match your design needs.', 'nexter-extension'),
        popDesc: __('Enable or disable core theme features to match your design needs.', 'nexter-extension'),
        read_link: "https://nexterwp.com/docs/nexter-theme-optimization-controls/",
        doclink: "https://nexterwp.com/docs/nexter-theme-optimization-controls/",
        formField: { key: 'theme-performance', label: __('Theme Performance', 'nexter-extension') },
    },
    {
        name: __('Global Color Palette', 'nexter-extension'),
        crd_desc: __('Manage the overall color scheme of your site using theme.json color palette, ensuring a consistent look across all elements.', 'nexter-extension'),
        read_link: "https://nexterwp.com/docs/set-global-colors/",
        cust_link: nexterCustLink + "?autofocus[panel]=panel-styling-colors"
    },
    {
        name: __('Global Colors', 'nexter-extension'),
        crd_desc: __('Manage the overall color scheme of your site, ensuring a consistent look across all elements.', 'nexter-extension'),
        read_link: "https://nexterwp.com/docs/styling-colors-option/",
        cust_link: nexterCustLink + "?autofocus[panel]=panel-styling-colors"
    },
    {
        name: __('Global Typography', 'nexter-extension'),
        crd_desc: __('Set your site’s default fonts and styles to maintain a uniform typography throughout.', 'nexter-extension'),
        read_link: "https://nexterwp.com/docs/typography-options/",
        cust_link: nexterCustLink + "?autofocus[section]=section-general-typo"
    },
    {
        name: __('Site Logo & Favicon', 'nexter-extension'),
        crd_desc: __('Set your website logo and favicon.', 'nexter-extension'),
        read_link: "https://nexterwp.com/docs/nexter-customiser-settings-explained/",
        cust_link: nexterCustLink + "?autofocus[section]=title_tagline"
    },
    {
        name: __('Blog Settings', 'nexter-extension'),
        crd_desc: __('Customize the layout and appearance of your blog posts and archive pages.', 'nexter-extension'),
        read_link: "https://nexterwp.com/docs/customise-single-blog-post/",
        cust_link: nexterCustLink + "?autofocus[panel]=panel-blog-layout"
    },
    {
        name: __('Container Settings', 'nexter-extension'),
        crd_desc: __('Set the width and structure of your content areas to create a responsive and visually clean layout.', 'nexter-extension'),
        read_link: "https://nexterwp.com/docs/enhance-appearance-with-general-settings/#Container",
        cust_link: nexterCustLink + "?autofocus[section]=section-site-layout-container"
    },
    {
        name: __('Header Settings', 'nexter-extension'),
        crd_desc: __('Enable or disable the default theme header.', 'nexter-extension'),
        read_link: "https://nexterwp.com/docs/enhance-appearance-with-general-settings/#Header",
        cust_link: nexterCustLink + "?autofocus[section]=section-header-mode"
    },
    {
        name: __('Footer Settings', 'nexter-extension'),
        crd_desc: __('Enable or disable the default theme footer.', 'nexter-extension'),
        read_link: "https://nexterwp.com/docs/enhance-appearance-with-general-settings/#Footer",
        cust_link: nexterCustLink + "?autofocus[section]=section-footer-mode"
    },
    {
        name: __('Body Style', 'nexter-extension'),
        crd_desc: __('Control the background and overall look of the main body of your site.', 'nexter-extension'),
        read_link: "https://nexterwp.com/docs/enhance-appearance-with-general-settings/#Body-Style",
        cust_link: nexterCustLink + "?autofocus[section]=section-body-style"
    },
    {
        name: __('Selection Text Color', 'nexter-extension'),
        crd_desc: __('Change the highlight color when users select text on your site for a more personalized experience.', 'nexter-extension'),
        read_link: "https://nexterwp.com/docs/enhance-appearance-with-general-settings/#Select-Text-Color",
        cust_link: nexterCustLink + "?autofocus[section]=section-selected-text-style"
    },
];


var theme_perfomance_opt = [
    {
        name: __('Disable Theme Container', 'nexter-extension'),
        id: 'container_css',
        tooltip: __('Disable container settings from theme customizer.', 'nexter-extension'),
        bottom : true
    },
    {
        name: __('Disable Theme Header Footer', 'nexter-extension'),
        id: 'header_footer_css',
        tooltip: __('Disable theme header and footer from theme customizer.', 'nexter-extension'),
        bottom : true
    },
    {
        name: __('Disable Reset CSS', 'nexter-extension'),
        id: 'reset_min_css',
        tooltip: __('Remove reset CSS.', 'nexter-extension'),
        bottom : true
    },
    {
        name: __('Disable Theme Sidebar', 'nexter-extension'),
        id: 'sidebar_css',
        tooltip: __('Disable sidebar settings from theme customizer.', 'nexter-extension'),
        bottom : true
    },
    {
        name: __('Disable Theme CSS', 'nexter-extension'),
        id: 'theme_min_css',
        tooltip: __('Remove the default theme CSS', 'nexter-extension')
    },
    {
        name: __('Disable Theme Woo CSS', 'nexter-extension'),
        id: 'woocommerce_min_css',
        tooltip: __('Remove the WooCommerce CSS added by theme.', 'nexter-extension')
    },
    {
        name: __('Disable Skip Link', 'nexter-extension'),
        id: 'skip_link',
        tooltip: __('Remove the "Skip to content" link.', 'nexter-extension')
    },
]

const ThemeCustomizer = () => {

    const [enabledSettings, setEnabledSettings] = useState(() => {
        let themeSettings = nxtext_ajax_object?.dashData?.nxtThemeSetting || {};
    
        // Initialize the settings object
        const defaultSettings = {
            'theme-performance': {
                switch: themeSettings.switch ? themeSettings.switch : false,
                values: {
                    container_css : 0,
                    header_footer_css : 0,
                    reset_min_css : 0,
                    sidebar_css : 0,
                    theme_min_css : 0,
                    woocommerce_min_css : 0,
                    skip_link : 0
                }
            }
        };
    
        // Check if keys are present and merge with defaults
        if (!themeSettings || !themeSettings['values']) {
            themeSettings = defaultSettings['theme-performance'];
        }else if(themeSettings && themeSettings['switch'] === undefined){
            themeSettings['switch'] = defaultSettings['theme-performance']['switch']
        }

        return {
            ...themeSettings,
        };
    });

    const [nexterThemeIntall, setNexterThemeIntall] = useState(nxtext_ajax_object?.dashData?.nexterThemeIntall || false);

    const installNxtTheme = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('action', 'nexter_ext_theme_install');
        formData.append('nexter_nonce', nxtext_ajax_object.ajax_nonce);
        formData.append('slug', 'nexter');
        
        nxtdash_install_theme(e, formData, setNexterThemeIntall, 'welcome');
    }

    const tooltipSVG = <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.48 7A5.48 5.48 0 1 1 1.52 7 5.48 5.48 0 0 1 12.48 7z" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 9.333V7" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 4.666h.006" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /></svg>

    const features = [
        "Bare-minimum core — no unnecessary code or hidden bloat",
        "Lightning-fast performance with clean, optimized markup",
        "Fully compatible with Gutenberg, Elementor & major builders",
        "Built for SEO & Core Web Vitals from the ground up",
        "A reliable base for any type of WordPress site — simple or complex",
    ];

    const [extType, setExtType] = useState('');
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [popupInputValue, setPopupInputValue] = useState({});

    const handleOpenPopup = (data) => {
        setExtType(data.key)
        setPopupData(data);
        const initialPopupInputValue = {};
        Object.keys(data.formField).forEach(key => {
            initialPopupInputValue[key] = enabledSettings[key] || '';
        });
        setPopupInputValue(initialPopupInputValue);
        setIsPopupVisible(true);
    };

    const handleClosePopup = () => {
        setIsPopupVisible(false);
        setPopupData(null);
        setPopupInputValue({});
    };

    const handleCheckboxChange = (e) => {
        const updateSwitch = { ...enabledSettings }
        // Ensure the key exists with proper structure
        if (!updateSwitch) {
            updateSwitch = { switch: false, values: [] };
        }
        updateSwitch['switch'] = e.target.checked
        setEnabledSettings(updateSwitch)
        
        const formData = new FormData();
        formData.append('action', 'nexter_theme_settings_save');
        formData.append('themeopt', JSON.stringify(updateSwitch)); 
        formData.append('nexter_nonce', nxtext_ajax_object.ajax_nonce);
        nxtdash_fetch_api(formData)
    };

    const handleCheckbox = (e) => {
        const updatedSettings = { ...enabledSettings };
        // Ensure updatedSettings.values exists as an object
        if(!updatedSettings?.values){
            updatedSettings.values = updatedSettings?.values || {};
        }

        // Get the current key being toggled
        const key = e.target.value;

        // Set value based on checked state
        if (e.target.checked) {
            updatedSettings.values[key] = 1;
        } else {
            updatedSettings.values[key] = 0;
        }
        setEnabledSettings(updatedSettings);
    };
    
    const handlePopupSave = (e) => {
        const formData = new FormData();
        formData.append('action', 'nexter_theme_settings_save');
        formData.append('themeopt', JSON.stringify(enabledSettings)); 
        formData.append('nexter_nonce', nxtext_ajax_object.ajax_nonce);

        nxtdash_save_data(e, formData)
    };

    return (
        <>
            <div className='nxtext_theme_ctm_inn_main nxtext_main_container'>
                <div className='nxtext_section_heading_cover'>
                    <h3 className='nxtext_primary_heading'>{!activateTheme ? __('Nexter Theme', 'nexter-extension') : __('Theme Customizer', 'nexter-extension')}</h3>
                </div>
                { !activateTheme  &&
                    <>
                    <section className="nxt-install-blocks-sec">
                        <div className='nxt-ins-block-cover'>
                            <div className="nxt-ins-block-inner">
                                <span className="badge">
                                    {__('Ultra-Lightweight WordPress Theme', 'nexter-extension')}
                                </span>
                                <h1 className="nxt-ins-heading">
                                    {__(
                                        'Start With the Lightest, Fastest Foundation for Your Website',
                                        'nexter-extension'
                                    )}
                                </h1>
                                <p className='nxt-ins-desc'>
                                    {__(
                                        'Nexter Theme gives you a rock-solid, super-clean base to build on — no heavy CSS frameworks, no bloated JavaScript, just a minimal, performance-first theme that keeps your site fast and stable while you design freely with Gutenberg or your favorite tools.',
                                        'nexter-extension'
                                    )}
                                </p>
                                <div className="nxt-ins-btns">
                                    { (!activateTheme && !nexterThemeIntall) && 
                                        <button className="ins-btn-primary" onClick={(e)=>{ installNxtTheme(e)}}>{__('Install Nexter Theme', 'nexter-extension')}</button>
                                    }
                                    { (!activateTheme && nexterThemeIntall) && 
                                        <a className="ins-btn-primary" href={`${adminLink}themes.php?theme=nexter`} target='_blank'>{__('Activate Theme', 'nexter-extension')}</a>
                                    }
                                    <a href={'https://nexterwp.com/nexter-theme/?utm_source=wpbackend&utm_medium=banner&utm_campaign=nextersettings'} rel="noopener noreferrer" target="_blank"  className="ins-btn-outline">
                                        {__('Explore All Features ', 'nexter-extension')}
                                    </a>
                                </div>
                                <ul className="nxt-feature-list">
                            {features.map((f, i) => (
                                <li key={i}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" fill="none" viewBox="0 0 14 15"><path fill="#1717cc" d="M6.373.505a7.13 7.13 0 0 0-3.7 1.474c-.535.41-1.228 1.183-1.628 1.813a9.6 9.6 0 0 0-.63 1.29c-.135.367-.28.931-.351 1.367-.085.534-.085 1.547 0 2.081a6.9 6.9 0 0 0 .65 2.04c.361.738.736 1.26 1.34 1.866a6.5 6.5 0 0 0 1.866 1.34 7 7 0 0 0 2.042.649c.534.084 1.548.084 2.083 0a7 7 0 0 0 2.041-.65 6.5 6.5 0 0 0 1.867-1.339 6.5 6.5 0 0 0 1.34-1.865c.241-.49.362-.81.493-1.304C13.96 8.61 14 8.251 14 7.49c0-.762-.041-1.12-.214-1.778a6.3 6.3 0 0 0-.493-1.304 6.5 6.5 0 0 0-1.34-1.865 6.5 6.5 0 0 0-1.867-1.34A6.8 6.8 0 0 0 8.058.56C7.655.497 6.756.467 6.373.505"/><path fill="#fff" d="M10.673 4.482c.137.044.348.249.406.4a.76.76 0 0 1-.017.561c-.088.178-4.599 4.654-4.802 4.766a.66.66 0 0 1-.624-.003c-.116-.06-2.193-1.92-2.547-2.279a.68.68 0 0 1-.205-.506c.005-.414.31-.693.72-.666.1.008.22.033.267.06.074.036 1.458 1.282 1.907 1.712l.129.126 2.05-2.046c1.126-1.123 2.086-2.062 2.135-2.087a.7.7 0 0 1 .58-.038"/></svg>
                                    {__(f, 'nexter-extension')}
                                </li>
                            ))}
                        </ul>
                            </div>
                            <div className="nxt-ins-img">
                                <img
                                    src={plugin_url + "assets/images/install-nexter-theme.png"}
                                    alt={__('Nexter Theme', 'nexter-extension')}
                                />
                            </div>
                        </div>

                        
                    </section>
                    </>
                }
                { activateTheme &&
                <>
                <div className='nxtext_theme_cstm_crds_cover'>
                    {Theme_cstm_crds.map((item) => (
                        <div className='nxtext_field_card' key={item.name}>
                            <div className='nxtext_card_top_detail'>
                                <div className='nxtext_field_card_h_strip'>
                                    <div className='nxtext_excrd_h_cover'>
                                        <h4 className='nxtext_secondary_heading'>{item.name}</h4>
                                        <div className='nxtext_tooltip'>{tooltipSVG}
                                            <span className="nxtext_tooltiptext">{item.crd_desc}</span>
                                        </div>
                                    </div>
                                    { item.cust_link ?
                                        <div className='nxtext_tgl_with_setting'>
                                            <a className='nxtext_ex_btn enabled' href={item.cust_link} target='_blank'>{nxtds_icons.setting}</a>
                                        </div>
                                        :
                                        <div className='nxtext-extra-tgl-wrap'>
                                            <button className={'nxtext_ex_btn' + (enabledSettings?.switch ? ' enabled' : '')} onClick={() => handleOpenPopup(item)} disabled={!enabledSettings?.switch}>{nxtds_icons.setting}</button>
                                            <div className="nxtext_block_tgl_btn_cover">
                                                <input className="nxtext_toggle_btn" id={"nxt_theme_toggle"} checked={enabledSettings?.switch || false} type="checkbox" onChange={(e) => handleCheckboxChange(e)} />
                                                <label className={"nxtext_switch_label"} htmlFor={"nxt_theme_toggle"}>
                                                    <span className="nxtext_switch_button"></span>
                                                </label>
                                            </div>
                                        </div>
                                    }
                                </div>
                                {item.read_link && !(nxtext_ajax_object?.dashData?.whiteLabel?.nxt_help_link == 'on') &&
                                    <div className='nxtext_links_cover'>
                                        <a target="_blank" rel="noopener noreferrer" href={item.read_link || 'https://nexterwp.com/nexter-theme/?utm_source=wpbackend&utm_medium=theme&utm_campaign=nextersettings'} className='nxtext_tertiary_btn nxtext_paragraph'>{__('Read Docs', 'nexter-extension')}</a>
                                    </div>
                                }
                            </div>
                            { item.name == 'WooCommerce' &&
                                <div className='nxt-coming-soon-ext'>{__('Coming Soon', 'nexter-extension')}</div>
                            }
                        </div>
                    ))}
                </div>
                {isPopupVisible &&
                    <div>
                        <>
                            <div className='nxtext_overlay' onClick={handleClosePopup}></div>
                            <div className={`nxtext_settings_popup ${extType}-popup`}>
                            <svg className='nxtext_close_icon' draggable={false} onClick={handleClosePopup} xmlns="http://www.w3.org/2000/svg" width="36" height="17" fill="none" viewBox="0 0 36 17"><path fill="#414B5A" d="M22.2 4.30665c-.26-.26-.68-.26-.94 0L18 7.55998l-3.26-3.26c-.26-.26-.68-.26-.94 0-.26.26-.26.68 0 .94l3.26 3.26L13.8 11.76c-.26.26-.26.68 0 .94.26.26.68.26.94 0L18 9.43998 21.26 12.7c.26.26.68.26.94 0 .26-.26.26-.68 0-.94l-3.26-3.26002 3.26-3.26c.2533-.25333.2533-.68 0-.93333Z"/></svg>

                                <div className='nxtext_popup_heading'>
                                    <h3 className='nxtext_primary_heading'>{popupData.name}</h3>
                                    <p className='nxtext_paragrph' dangerouslySetInnerHTML={{ __html: popupData.popDesc }}></p>

                                </div>
                                <div className='nxtext_popup_inner_main_co'>
                                    {Object.keys(popupData.formField).map((key) => {
                                        const field = popupData.formField[key];
                                        if(key == 'label'){
                                            return
                                        }
                                        return (

                                            <div className='nxtext_field_card_cover' key={key} id={field}>
                                                <div className='nxtext_crd_head_strip'>
                                                    <label htmlFor={key} className='nxtext_secondary_heading'>{field.label}</label>
                                                </div>
                                                <div className='nxtext_perfmnce_crds_maincover'>
                                                    {field === 'theme-performance' && (
                                                        <div className='nxtext_pop_in_cover'>
                                                            {theme_perfomance_opt.map((item, index) => (
                                                                <div className='nxtext_strip_tgl_cover' key={index.toString()}>
                                                                    <div className='nxtext_strip_tgl_h'>
                                                                        <label className='nxtext_paragrph' htmlFor={item.id}>{item.name}</label>
                                                                        {item.isNew &&
                                                                            <div className="nxt-new-ext">{ __( "NEW", 'nexter-extension' ) }</div>
                                                                        }
                                                                        <div className='nxtext_tooltip'>{tooltipSVG}
                                                                            <span className={"nxtext_tooltiptext"+(item.bottom ? ' bottom_tooltip' : '')}>{item.tooltip}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className='nxtext_tgl_with_setting'>
                                                                        <div className="nxtext_block_tgl_btn_cover">
                                                                            <input className="nxtext_toggle_btn" id={item.id} type="checkbox" value={item.id} onChange={(e)=>{ handleCheckbox(e)}} checked={!!enabledSettings?.values?.[item.id]}/>
                                                                            <label className="nxtext_switch_label" htmlFor={item.id}>
                                                                                <span className="nxtext_switch_button"></span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className='nxtext_popup_bottom'>
                                    {popupData.doclink &&
                                        <a className='nxtext_tertiary_btn' target="_blank" rel="noopener noreferrer" href={popupData.doclink}>{__('Read How it Works', 'nexter-extension')}</a>
                                    }
                                    <button className="nxtext_blue_common_btn" onClick={handlePopupSave}>{__('Save', 'nexter-extension')}</button>
                                </div>
                            </div>
                        </>
                    </div>
                }
                </>
            }
            </div>
        </>

    )
}


export default ThemeCustomizer;